/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolcardunknownerror3Inputs */

const en_toolcardunknownerror3 = /** @type {(inputs: Toolcardunknownerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unknown error`)
};

const pt_toolcardunknownerror3 = /** @type {(inputs: Toolcardunknownerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`erro desconhecido`)
};

/**
* | output |
* | --- |
* | "unknown error" |
*
* @param {Toolcardunknownerror3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const toolcardunknownerror3 = /** @type {((inputs?: Toolcardunknownerror3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolcardunknownerror3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toolcardunknownerror3(inputs)
	return pt_toolcardunknownerror3(inputs)
});
export { toolcardunknownerror3 as "toolCardUnknownError" }